export const FREIGHT_TABLE_PATH_PREFIX = "/tabela-frete";

export const FREIGHT_TABLE_LIST_PATH = FREIGHT_TABLE_PATH_PREFIX;

export function isFreightTablePath(path) {
  return String(path || "").indexOf(FREIGHT_TABLE_PATH_PREFIX) === 0;
}

export function addCarrierPath(freightTableId) {
  return `${FREIGHT_TABLE_PATH_PREFIX}/${freightTableId}/transportadora`;
}

export function addRoutePath(freightTableId) {
  return `${FREIGHT_TABLE_PATH_PREFIX}/${freightTableId}/rota`;
}

export function draftPath(freightTableId) {
  return `${FREIGHT_TABLE_PATH_PREFIX}/rascunho/${freightTableId}`;
}
